import React, { Component } from 'react';
import { connect } from 'react-redux';
import CustomerForm from './components/checkout/customerForm';
import OrderSummary from './components/orderSummary';
import {
  saveCustomerDetails,
  updateContactInfo,
  addressLines,
  getPropertyDetails,
  fetchAbnDetails,
  fetchCurrentOrder,
  getRoles,
  getAccounts,
  getAccountInfo,
  resetCheckoutLoaders,
  validateAccountReferenceNumber,
  resetAbnLookupProps,
  resetAddressLookupProps
} from '../actions/checkout';
import history from '../history';
import { redirectToLoginPage, userExpirySession } from '../actions/login';
import { resetPurchaseEvent } from '../actions/pxpay';
import Cookies from 'universal-cookie';

import { Modal } from './components/compat/BootstrapCompat';
import './CheckoutPage.css';

export const BLACKLIST_ACCOUNTS = ['A0200848', 'A0096340', 'A0101117', 'A0060336', 'A0060335', 'A0074832', 'A0015151'];
const YEARLY_DISCOUNT = 'YearlyDiscount';
const ADDRESS_LOOKUP_AUTO_MANUAL_ENTRY_TRIGGER_LENGTH = '5';
const businessOnlyKeys = ['role', 'businessName', 'businessTerms', 'legalEntityName', 'abn', 'abnManual']

const containsPOBox = (str) => {
  if (!str) {
    return false;
  }
  const lowerCaseStr = str.toLowerCase();
  return (
    lowerCaseStr.includes("po box") ||
    lowerCaseStr.includes("pobox") ||
    lowerCaseStr.includes("po box")
  );
}

const STATE_ABBREVIATIONS = {
  // AU
  "new south wales": "NSW",
  "victoria": "VIC",
  "queensland": "QLD",
  "south australia": "SA",
  "western australia": "WA",
  "tasmania": "TAS",
  "northern territory": "NT",
  "australian capital territory": "ACT",

  // NZ
  "northland": "NTL",
  "auckland": "AUK",
  "waikato": "WKO",
  "bay of plenty": "BOP",
  "gisborne": "GIS",
  "hawke's bay": "HKB",
  "taranaki": "TKI",
  "manawatu-wanganui": "MWT",
  "wellington": "WGN",
  "tasman": "TAS",
  "nelson": "NSN",
  "marlborough": "MBH",
  "west coast": "WTC",
  "canterbury": "CAN",
  "otago": "OTA",
  "southland": "STL"
};

function abbreviateState(address) {
  if (!address) return address;

  const parts = address.split(" ");

  for (let i = parts.length - 2; i >= 0; i--) {
    const potentialStateName = parts.slice(i, parts.length - 1).join(" ");
    // Convert both the potential state name and dictionary keys to lowercase for comparison
    const matchedState = Object.keys(STATE_ABBREVIATIONS).find(
      state => state.toLowerCase() === potentialStateName.toLowerCase()
    );
    if (matchedState) {
      parts.splice(i, parts.length - i - 1, STATE_ABBREVIATIONS[matchedState]);
      return parts.join(" ");
    }
  }

  return address;
}

class Checkout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      totalDays: 30,
      totalMonths: 0,
      userTotalMonths: 0,
      minCost: 0,
      conditionalTC: false,
      rppProduct: null,
      quotes: [],
      order: {},
      totalPrice: 0,
      customer: {},
      showBusinessOption: true,
      business: true,
      addressOption: false,
      mailingAddressAutocomplete: true,
      errorMessages: {
        abn: false,
        abnManual: false,
        abnFormat: false,
        abnInvalid: false,
        accountReferenceNumber: true,
        accountReferenceNumberValid: false,
        accountType: false,
        businessName: false,
        businessTerms: false,
        email: false,
        industry: false,
        legalEntityName: false,
        mobileNumber: false,
        name: false,
        preferredContact: false,
        role: false,
        singleAddressLine: false,
        state: false,
        streetAddress: false,
        streetAddressFormat: false,
        suburbCity: false,
        postcode: false,
        terms: false,
        title: false,
        trialTerms: false
      },
      required: {
        abn: true,
        abnManual: false,
        accountReferenceNumber: false,
        accountType: true,
        businessName: false,
        businessTerms: true,
        email: true,
        industry: true,
        legalEntityName: false,
        mobileNumber: true,
        name: true,
        postcode: false,
        role: true,
        singleAddressLine: true,
        state: false,
        streetAddress: false,
        suburbCity: false,
        terms: false,
        title: true,
        trialTerms: false
      },
      disabled: {
        abn: false,
        abnManual: false,
        businessName: false,
        email: true,
        industry: false,
        legalEntityName: false,
        mobileNumber: false,
        name: true,
        postcode: false,
        role: false,
        singleAddressLine: false,
        state: false,
        streetAddress: false,
        suburbCity: false,
        title: false
      },
      manualEntry: false,
      abnManualEntry: false,
      errors: false,
      paymentDetails: {
        channel: 'WEB',
        orderId: null,
        originatingPlatform: 'CORESTORE',
        paymentGateway: 'DPS',
        accountNumber: null,
        region: 'AU',
        accountGuid: null,
        payCode: 'TV',
        transactionType: 'PRE_AUTH'
      },
      originalTotalPrice: 0,
      isAgentVisbile: true,
      monthsDiscount: 0,
      vicDeedFormPopup: false,
      show: false,
      showEOFYOffer: false,
      coupon: null,
      isValidAccountReferenceNumber: false,
      submitBufferLoader: false,
      isVicProduct: false
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onSubmitCustomerDetails = this.onSubmitCustomerDetails.bind(this);
    this.onChangeBusinessOption = this.onChangeBusinessOption.bind(this);
    this.onAddressInputChange = this.onAddressInputChange.bind(this);
    this.onAddressFocus = this.onAddressFocus.bind(this);
    this.onAddressSelection = this.onAddressSelection.bind(this);
    this.onAbnChange = this.onAbnChange.bind(this);
    this.onAddressManualEntry = this.onAddressManualEntry.bind(this);
    this.onAddressCancelManualEntry = this.onAddressCancelManualEntry.bind(this);
    this.onAbnManualEntry = this.onAbnManualEntry.bind(this);
    this.onAbnCancelManualEntry = this.onAbnCancelManualEntry.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.hideEOFYOffer = this.hideEOFYOffer.bind(this);
    this.onAccountSelectorChange = this.onAccountSelectorChange.bind(this);
    this.onManualAccountInputChange = this.onManualAccountInputChange.bind(this);
    this.onAccountTypeSelectorChange = this.onAccountTypeSelectorChange.bind(this);
    this.checkExistingAccounts = this.checkExistingAccounts.bind(this);
    this.backToCart = this.backToCart.bind(this);
    this.isYearlyCouponApplied = this.isYearlyCouponApplied.bind(this);
    this.isMultipleYearlyCouponOrder = this.isMultipleYearlyCouponOrder.bind(this);
    this.forceAddressManualEntry = this.forceAddressManualEntry.bind(this);

    //SERVICES
    this.analyticsCheckout = this.props.SegmentAnalytics.analyticsCheckout.bind(this);
    this.trackCheckoutAbandonedCart = this.props.SegmentAnalytics.trackCheckoutAbandonedCart.bind(this);
    this.getItemsCount = this.props.ProductItemsService.getItemsCount.bind(this);
    this.trackGotoCart = this.props.SegmentAnalytics.trackGotoCart.bind(this);
    this.trackOrder = this.props.SegmentAnalytics.trackOrder.bind(this);
    this.analyticsIdentifyIndustry =
      this.props.SegmentAnalytics.analyticsIdentifyIndustry.bind(this);
    this.trackError = this.props.SegmentAnalytics.trackError.bind(this);
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  backToCart() {
    this.trackGotoCart(this.getItemsCount());
    history.push('/cart');
  }

  validateAndProceedToPayment(type) {
    if (this.props.login.relogin) {
      this.props.redirectToLoginPage();
    } else {
      const requiredFields = this.state.required;
      let customer = this.state.customer;
      let errorMessages = this.state.errorMessages;
      errorMessages.apiErrorMessages = [];
      let paymentDetails = this.state.paymentDetails;
      let errors = false;

      if (this.state.business && (
        errorMessages.abnFormat ||
        errorMessages.abnInvalid ||
        errorMessages.streetAddressFormat ||
        errorMessages.accountReferenceNumberValid
      )) {
        errors = true;
      }

      if (errorMessages.streetAddressFormat || errorMessages.accountReferenceNumberValid)
        errors = true;

      for (let requiredField in requiredFields) {
        if (customer[requiredField] === undefined) {
          customer[requiredField] = null;
        }
        if (
          requiredFields[requiredField] === true &&
          (customer[requiredField] === null ||
            customer[requiredField] === '' ||
            errorMessages[requiredField] ||
            customer[requiredField] === undefined)
        ) {
          errorMessages[requiredField] = true;
          if (
            this.state.business &&
            requiredField === 'abnManual' &&
            customer.abn !== null &&
            customer.abn !== '' &&
            !/^\s*$/.test(customer.abn)
          ) {
            errorMessages[requiredField] = false;
          }
          if (
            !errors &&
            this.state.business &&
            requiredField === 'abnManual' &&
            customer.abn !== null &&
            customer.abn !== ''
          ) {
            errors = false;
          } else {
            errors = true;
          }
        }
      }

      if (customer.industry === 'NONE' || customer.industry === '') {
        errorMessages.industry = true;
        errors = true;
      }

      if (!customer.preferredContact || customer.preferredContact === '') {
        customer.preferredContact = 'email';
      }

      if (customer.abn !== null && customer.abn !== '') {
        customer.abn = customer.abn.toString().replace(/\s/g, '');
      }

      if (customer.businessTerms === true) {
        customer.purpose = 'Business';
      } else {
        customer.abn = null;
        customer.abnManual = null;
        customer.businessName = customer.name;
        customer.businessTerms = null;
        customer.legalEntityName = customer.name;
        customer.purpose = 'Personal';
        customer.role = null;
      }

      if (this.state.mailingAddressAutocomplete === false && this.state.manualEntry === false) {
        errors = true;
        errorMessages.singleAddressLine = true;
      } else if (customer.singleAddressLine) {
        customer.singleAddressLine = abbreviateState(customer.singleAddressLine);
      }

      if (!customer.country) {
        customer.country = 'AU';
      }

      if (!this.state.business) {
        businessOnlyKeys.map((businessKey) => {
          errorMessages[businessKey] = false;
        })
      }

      this.setState({
        errorMessages: errorMessages,
        customer: customer,
        errors: errors,
        pendingPaymentType: type,
        submitBufferLoader: false
      });

      if (!errors && this.state.vicDeedFormPopup === false && !this.state.subscriptionPopup) {
        this.analyticsIdentifyIndustry(
          this.props.registration.emailValidation.guid,
          customer.industry
        );
        this.trackOrder(this.props.order, type, this.props.hmcw);

        let accountGuid = null;
        for (
          let accountIndex = 0;
          accountIndex < this.props.login.accounts.length;
          accountIndex++
        ) {
          if (
            customer.accountReferenceNumber ===
            this.props.login.accounts[accountIndex].accountNumber
          ) {
            accountGuid = this.props.login.accounts[accountIndex].crmAccountGuid;
          }
        }

        paymentDetails.orderId = this.props.order.id;
        paymentDetails.accountGuid = accountGuid;
        paymentDetails.accountNumber = customer.accountReferenceNumber;
        this.setState({paymentDetails: paymentDetails});
        // Note: agent's name is currently stored by GTM as {'agent': <name>}
        const agent = localStorage.getItem('agent');
        const agentName = agent ? JSON.parse(agent).agent : null;
        let order = {
          processStatus: 'AUTO',
          accountNumber: customer.accountReferenceNumber,
          accountGuid: accountGuid,
          customer: customer,
          quoteConfiguration: this.props.order.quoteConfiguration
        };
        if (agentName) {
          order.assistingAgent = agentName
          order.assistanceContext = 'live_chat_core_store'
        }
        localStorage.removeItem('agent')
        if (this.props.contactInfo.title !== customer.title) {
          this.props.updateContactInfo({ ...this.props.contactInfo, title: customer.title });
        }

        this.props.saveCustomerDetails(order, type, paymentDetails).then(() => {
          if (this.props.apiErrorMessages?.length > 0) {
            this.handleClose();
            this.setState(prevState => ({
              errorMessages: {
                ...prevState.errorMessages,
                apiErrorMessages: this.props.apiErrorMessages
              },
              errors: true
            }));
          }
        });
      } if (!errors && this.state.vicDeedFormPopup) {
        this.handleShow();
        this.setState({
          vicDeedFormPopup: false
        });
      } if (!errors && this.state.subscriptionPopup) {
        this.handleShow();
        this.setState({
          subscriptionPopup: false
        });
      } if (errors) {
        let trackErrorMessages = {};
        Object.keys(errorMessages).forEach(function (error) {
          if (errorMessages[error]) {
            trackErrorMessages[error] = errorMessages[error];
          }
        });
        this.trackError('Proceed to Payment', null, trackErrorMessages, null);
      }
    }
  }

  onSubmitCustomerDetails(type) {
    this.setState({
      submitBufferLoader: true
    });

    this.props.userExpirySession();
    setTimeout(
      function () {
        this.validateAndProceedToPayment(type);
      }.bind(this),
      1000
    );
  }

  addressManualEntryValidation(key, value, errorMessages) {
    const addressFields = ['streetAddress', 'suburbCity', 'postcode', 'state']
    if (addressFields.includes(key)) {
      errorMessages.apiErrorMessages = [];
      if (value == null || value == '' || value == 'null') {
        errorMessages[key] = true;
      } else {
        const trimmedValue = value.replace(/\s/g, '')
        if (key === 'streetAddress') {
          if (trimmedValue.length < 3) {
            errorMessages['streetAddress'] = true;
          } else if (!/^[a-z,\-\sA-Z0-9]*$/.test(value)) {
            errorMessages['streetAddress'] = false;
            errorMessages['streetAddressFormat'] = true;
          } else if (containsPOBox(value)) {
            errorMessages['streetAddress'] = true;
            errorMessages['streetAddressFormat'] = false;
          } else {
            errorMessages['streetAddress'] = false;
            errorMessages['streetAddressFormat'] = false;
          }
        }
        else if (key === 'suburbCity') {
          if (!/^[a-zA-Z\s]*$/.test(value) || trimmedValue.length < 3) {
            errorMessages['suburbCity'] = true;
          } else {
            errorMessages['suburbCity'] = false;
          }
        }
        else if (key === 'postcode') {
          if (!/^[0-9]{4}$/.test(trimmedValue)) {
            errorMessages['postcode'] = true;
          } else {
            errorMessages['postcode'] = false;
          }
        }
      }
    }
    return errorMessages;
  }

  onInputChange(event, type) {
    const requiredFields = this.state.required;
    let customerDetails = this.state.customer;
    let errorMessages = this.state.errorMessages;

    let key, value;
    if (type === 'franchise') {
      key = 'franchiseGroup';
      value = event.length > 0 ? event[0] : '';
    } else {
      key = event.target.name;
      value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
      if (requiredFields[key]) {
        if (key === 'title') {
          if (!["Mr.", "Ms.", "Mrs.", "Dr.", "Prof.", "Mx."].includes(value)) {
            errorMessages[key] = true;
          } else {
            errorMessages[key] = false;
          }
        }
        if (key === 'name') {
          if (!/^((\b[a-zA-Z'-]{2,40}\b)\s*){2,}$/.test(value)) {
            errorMessages[key] = true;
          } else {
            errorMessages[key] = false;
          }
        }
        if (key === 'mobileNumber') {
          if (!/^(\d{10}|(\d{4} \d{3} \d{3}))$/.test(value)) {
            errorMessages[key] = true;
          } else {
            errorMessages[key] = false;
          }
        }
        if (key === 'email') {
          if (
            !/^(([^<>()[\]\\.,;:\s@]+(\.[^<>()[\]\\.,;:\s@]+)*)|(.+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              value
            )
          ) {
            errorMessages[key] = true;
          } else {
            errorMessages[key] = false;
          }
        }
        if (key === 'abn') {
          let resultValue = value.toString().replace(/\s*/g, '')
          if (resultValue.length == 9 || resultValue.length == 11) {
            errorMessages['abnInvalid'] = false;
            if (
              /^\d+$/.test(resultValue)
            ) {
              errorMessages['abnFormat'] = false;
              errorMessages['abn'] = false;
              this.onAbnChange(resultValue)
            } else {
              errorMessages['abnFormat'] = true;
              errorMessages['abn'] = true;
            }
          } else {
            errorMessages['abnFormat'] = true;
            errorMessages['abn'] = true;
            customerDetails.businessName = '';
            customerDetails.legalEntityName = '';
          }
        }

        if (key === 'accountReferenceNumber') {
          if (
            !/^(\d{1,8})$|^([aAxX]{1}\d{7})$|^([inqstvwzINQSTVWZ]{1}\d{5})$/.test(
              value.toLowerCase()
            )
          ) {
            errorMessages[key] = true;
          } else {
            errorMessages[key] = false;
          }

          //check blacklist
          let blacklist_accs = BLACKLIST_ACCOUNTS.map((acc) => acc.toLowerCase());
          if (blacklist_accs.includes(value.toLowerCase())) {
            errorMessages[key] = true;
          }
        }

        if (
          key === 'role' ||
          key === 'state' ||
          key === 'businessName' ||
          key === 'legalEntityName'
        ) {
          if (
            value !== null &&
            value !== '' &&
            value !== 'null' &&
            /^[a-zA-Z0-9][a-z.\-\s'A-Z0-9_]*$/.test(value) &&
            value.replace(/\s/g, '').length > 1
          ) {
            errorMessages[key] = false;
          } else {
            errorMessages[key] = true;
          }
        }

        if (key === 'abnManual') {
          customerDetails.abn = value;
          const resultValue = value.toString().replace(/\s*/g, '')
          if (
            (resultValue.length == 9 || resultValue.length == 11) &&
            /^\d+$/.test(resultValue)
          ) {
            errorMessages['abnManual'] = false;
            errorMessages['abnFormat'] = false;
          } else {
            errorMessages['abnManual'] = true;
            errorMessages['abnFormat'] = true;
          }
        }

        errorMessages = this.addressManualEntryValidation(key, value, errorMessages);

        if (key === 'industry') {
          if (value !== 'NONE' && value !== '') {
            errorMessages[key] = false;
          } else {
            errorMessages[key] = true;
          }
        }
        if (key === 'businessTerms') {
          if (value) {
            errorMessages.businessTerms = false;
          } else {
            errorMessages.businessTerms = true;
          }
        }
        if (key === 'terms') {
          if (value) {
            errorMessages.terms = false;
          } else {
            errorMessages.terms = true;
          }
        }
        if (key === 'trialTerms') {
          if (value) {
            errorMessages.trialTerms = false;
          } else {
            errorMessages.trialTerms = true;
          }
        }
      }
    }
    if (key === 'accountType') {
      if (value) {
        errorMessages.accountType = false;
        errorMessages.accountReferenceNumber = false;
      } else {
        errorMessages.accountType = true;
      }
    }
    if (key !== 'abnManual') {
      customerDetails[key] = value;
    }

    this.setState({
      customer: customerDetails,
      errorMessages: errorMessages
    });
  }

  onChangeBusinessOption(event) {
    let required = this.state.required;
    let customer = this.state.customer;
    if (event.target.value === 'Business') {
      required.role = true;
      required.abn = true;
      required.businessTerms = true;
      customer.legalEntityName = null;
      customer.businessName = null;
      this.setState({
        business: true,
        required: required,
        customer: customer
      });
    } else if (event.target.value === 'Personal') {
      let errorMessages = this.state.errorMessages;
      required.role = false;
      required.abn = false;
      required.businessName = false;
      required.legalEntityName = false;
      required.businessTerms = false;
      errorMessages.abnFormat = false;
      errorMessages.abnInvalid = false;
      customer.abn = null;
      customer.abnManual = null;
      customer.businessName = null;
      customer.businessTerms = null;
      customer.industry = null;
      customer.role = null;
      customer.legalEntityName = null;
      businessOnlyKeys.map((businessKey) => {
        errorMessages[businessKey] = false;
      })
      this.setState({
        business: false,
        required: required,
        errorMessages: errorMessages,
        customer: customer
      });
    }
  }

  onAddressInputChange(event) {
    let customerDetails = this.state.customer;
    let errorMessages = this.state.errorMessages;
    if (event.target.value !== null && event.target.value !== '') {
      errorMessages.singleAddressLine = false;
      errorMessages.apiErrorMessages = [];
      if (containsPOBox(event.target.value)) {
        errorMessages.singleAddressLine = true;
      }
    }
    customerDetails.singleAddressLine = event.target.value;
    this.setState({
      customer: customerDetails,
      errorMessages: errorMessages,
      mailingAddressAutocomplete: false
    }, () => {this.props.addressLines(event.target.value.replace(/\b(?:[\s]*,[\s]*)\b/gi, '/'))});
  }

  onAddressFocus() {
    this.setState({
      addressOption: true
    });
  }

  onAddressSelection(line) {
    let customerDetails = this.state.customer;
    let errorMessages = this.state.errorMessages;
    errorMessages.singleAddressLine = false;

    //Fetch property details
    this.props.getPropertyDetails(line.propertyId).then(
      function (propertyDetailsAction) {
        const propertyDetails = (propertyDetailsAction && (propertyDetailsAction.data || propertyDetailsAction.body))
          ? (propertyDetailsAction.data || propertyDetailsAction.body)
          : this.props.propertyDetails;
        if (propertyDetails.streetAddress) {
          customerDetails.streetAddress = propertyDetails.streetAddress.replace(
            /\//g,
            ', '
          );
          customerDetails.suburbCity = propertyDetails.suburbCity;
          customerDetails.state = propertyDetails.state;
          customerDetails.postcode = propertyDetails.code;
        } else if (!this.state.manualEntry)
          errorMessages.singleAddressLine = true;
      }.bind(this)
    );
    customerDetails.singleAddressLine = line.suggestion.replace(/\//g, ', ');

    this.setState({
      customer: customerDetails,
      addressOption: false,
      mailingAddressAutocomplete: true,
      errorMessages: errorMessages
    });
  }

  onAbnChange(newAbn) {
    let customerDetails = this.state.customer;
    let errorMessages = this.state.errorMessages;
    let abn = newAbn;
    abn = abn.toString().replace(/\s*/g, '');
    if (abn !== null && abn !== '') {
      this.props.fetchAbnDetails(abn);
      if (!/^\d+$/.test(abn)) {
        errorMessages['abnFormat'] = true;
      } else {
        errorMessages['abnFormat'] = false;
        errorMessages['abn'] = false;
      }
    } else {
      customerDetails.businessName = '';
      customerDetails.legalEntityName = '';
    }
    this.setState({
      customer: customerDetails,
      errorMessages: errorMessages
    });
  }

  onAddressManualEntry() {
    let required = this.state.required;
    let errorMessages = this.state.errorMessages;
    let customer = this.state.customer;
    required.singleAddressLine = false;
    required.streetAddress = true;
    required.suburbCity = true;
    required.state = true;
    required.postcode = true;
    customer.singleAddressLine = null;

    if (customer.streetAddress != null) {
      customer.streetAddress.trim();
    }

    errorMessages.singleAddressLine = false;

    this.setState({
      required: required,
      manualEntry: true,
      errorMessages: errorMessages,
      customer: customer
    });
  }

  onAddressCancelManualEntry() {
    let required = this.state.required;
    let errorMessages = this.state.errorMessages;
    let customer = this.state.customer;
    required.singleAddressLine = true;
    required.streetAddress = false;
    required.suburbCity = false;
    required.state = false;
    required.postcode = false;
    errorMessages.state = false;
    errorMessages.streetAddress = false;
    errorMessages.streetAddressFormat = false;
    errorMessages.suburbCity = false;
    errorMessages.postcode = false;
    customer.streetAddress = null;
    customer.suburbCity = null;
    customer.state = null;
    customer.postcode = null;
    this.setState({
      required: required,
      manualEntry: false,
      errorMessages: errorMessages,
      customer: customer
    });
  }

  onAbnManualEntry() {
    let required = this.state.required;
    required.abn = false;
    required.abnManual = true;
    required.legalEntityName = true;
    required.businessName = true;
    this.setState({
      required: required,
      abnManualEntry: true
    });
  }

  onAbnCancelManualEntry() {
    let required = this.state.required;
    let errorMessages = this.state.errorMessages;
    required.abn = true;
    required.abnManual = false;
    required.legalEntityName = false;
    required.businessName = false;
    errorMessages.abnManual = false;
    errorMessages.businessName = false;
    errorMessages.legalEntityName = false;
    this.setState({
      customer: {
        ...this.state.customer,
        abn: '',
        businessName: '',
        legalEntityName: ''
      },
      required: required,
      abnManualEntry: false,
      errorMessages: errorMessages
    });
  }

  isYearlyCouponApplied(coupon = this.props.order?.quotes?.coupon) {
    return (
      coupon &&
      coupon.discountServiceType === YEARLY_DISCOUNT
    );
  }

  isMultipleYearlyCouponOrder(orderQuotes) {
    return (
      this.isYearlyCouponApplied(orderQuotes.coupon) &&
      orderQuotes.quotes &&
      orderQuotes.quotes.length > 1
    );
  }

  standardizeTitle(title) {
    // Convert the title to lowercase and then capitalize the first letter
    let standardizedTitle = title.toLowerCase();
    standardizedTitle = standardizedTitle.charAt(0).toUpperCase() + standardizedTitle.slice(1);

    // Add a period at the end if it's not there already
    if (standardizedTitle.charAt(standardizedTitle.length - 1) !== '.') {
        standardizedTitle += '.';
    }

    return standardizedTitle;
  }

  resetOrder(order) {
    let disabled = this.state.disabled
    let errorMessages = this.state.errorMessages;
    let quotes = order.quotes ? order.quotes.quotes : [];
    let orderItems = order.quoteConfiguration ? order.quoteConfiguration.products : [];
    let totalMonths = 0;
    let userTotalMonths = 0;
    let totalDays = this.state.totalDays;
    let showBusinessOption = this.state.showBusinessOption;
    let required = this.state.required;
    let customer = order.customer;
    let totalPrice = order.quotes ? order.quotes.cartTotal : 0;
    let minCost = order.quotes ? order.quotes.cartMinTotal : 0;
    let conditionalTC = false;
    let rppProduct = null;
    let discountApplied = false;
    let monthsDiscount = 0;
    let isAgentVisbile = true;
    let vicDeedFormPopup = false;
    let subscriptionPopup = false
    let isReport = false;
    let productCount = 0;
    let reportCount = 0;
    let isRPP = false;
    let isVicProduct = false;

    if (this.props.contactInfo.title) {
      customer.title = this.standardizeTitle(this.props.contactInfo.title)
      disabled.title = true
    }

    let originalTotalPrice = 0;
    for (let quoteIndex = 0; quoteIndex < quotes.length; quoteIndex++) {
      quotes[quoteIndex].totalPerMonth = parseFloat(quotes[quoteIndex].totalPerMonth).toFixed(2);
      let originalMonthlyPrice =
        this.isYearlyCouponApplied(order.quotes.coupon) && quotes[quoteIndex].yearlyDiscount > 0
          ? quotes[quoteIndex].originalYearlyPrice
          : quotes[quoteIndex].originalPrice;
      originalTotalPrice = originalTotalPrice + originalMonthlyPrice;
      quotes[quoteIndex].headline =
        quotes[quoteIndex].headLine.charAt(0).toUpperCase() + quotes[quoteIndex].headLine.slice(1);
      if (parseFloat(quotes[quoteIndex].totalPerMonth) > 0) {
        quotes[quoteIndex].contractMonths = 12;
      } else if (parseFloat(quotes[quoteIndex].totalPerMonth) < 1) {
        quotes[quoteIndex].contractMonths = 0;
      }
    }

    for (let index = 0; index < orderItems.length; index++) {
      let item = orderItems[index];
      if (quotes[index].type === 'RPPRealEstate') {
        rppProduct = item.configuration.industry;

        // isRPP
        if (item.configuration.package !== 'lite') {
          isRPP = true;
        }

        if (item.configuration.industry === 'investors') {
          //Set default value for industry selector investors
          customer.industry = 'INVESTOR';

          if (item.configuration.package === 'basic') {
            quotes[index].contractMonths = 6;
            if (totalMonths === 0) {
              totalMonths = 6;
              userTotalMonths = 6;
            }
          } else if (item.configuration.package === 'one_month') {
            quotes[index].contractMonths = 1;
            if (totalMonths === 0) {
              totalMonths = 1;
              userTotalMonths = 1;
            }
            if (orderItems.length > 1) {
              conditionalTC = true;
            }
          }
        }
        //Set default value for industry selector mortage brokes
        if (item.configuration.industry === 'mortgage_brokers_and_financial_planners') {
          customer.industry = 'FINANCE';
        }
        if (item.configuration.industry === 'real_estate_agencies_and_valuers') {
          if (item.configuration.geography.national === true) {
            vicDeedFormPopup = true;
            isVicProduct = true;
          } else if (
            item.configuration.geography.states !== null &&
            item.configuration.geography.states.length > 0
          ) {
            for (
              let subIndex = 0;
              subIndex < item.configuration.geography.states.length;
              subIndex++
            ) {
              if (item.configuration.geography.states[subIndex] === 'VIC') {
                vicDeedFormPopup = true;
                isVicProduct = true;
              }
            }
          }
          if (item.configuration.package === 'one_month') {
            quotes[index].contractMonths = 1;
            if (totalMonths === 0) {
              totalMonths = 1;
              userTotalMonths = 1;
            }
          }
        }
      }

      if (quotes[index].productGroup === 'Report Subscription') {
        reportCount++;
        isReport = true;
      } else {
        productCount++;
      }
      quotes[index].userContractMonths =
        quotes[index].minimumInitialTerm +
        (quotes[index].provisioningInfo && quotes[index].provisioningInfo.discountPeriods
          ? quotes[index].provisioningInfo.discountPeriods
          : 0);
      if (userTotalMonths === 0 || userTotalMonths < quotes[index].userContractMonths) {
        userTotalMonths = quotes[index].userContractMonths;
      }

      if (quotes[index].userContractMonths >= 12) {
        totalMonths = 12;
        totalDays = 90;
      }
    }

    if (totalPrice > 0) {
      required.trialTerms = false;
      required.terms = true;
    } else {
      required.trialTerms = true;
      required.terms = false;
    }

    if (
      customer.abn !== null &&
      customer.businessName === null &&
      customer.legalEntityName === null
    ) {
      errorMessages.abnInvalid = true;
    }

    if (customer.accountType === 'NEW_ACCOUNT') {
      required.accountReferenceNumber = false;
      disabled.abn = false;
    }


    //check if there are products and reports in order
    if ((productCount > 0 && reportCount > 0) || this.isMultipleYearlyCouponOrder(order.quotes))
      conditionalTC = true;
    if (this.checkHasSubscription(this.props.order)) {
      subscriptionPopup = true;
    }

    this.setState({
      totalDays: totalDays,
      totalMonths: totalMonths,
      userTotalMonths: userTotalMonths,
      quotes: quotes,
      order: order,
      totalPrice: totalPrice,
      originalTotalPrice: originalTotalPrice,
      customer: customer,
      showBusinessOption: showBusinessOption,
      errorMessages: errorMessages,
      minCost: minCost,
      conditionalTC: conditionalTC,
      rppProduct: rppProduct,
      isAgentVisbile: isAgentVisbile,
      monthsDiscount: monthsDiscount,
      vicDeedFormPopup: vicDeedFormPopup,
      subscriptionPopup: subscriptionPopup,
      discountApplied: discountApplied,
      coupon: order.quotes.coupon,
      isReport: isReport,
      isRPP: isRPP,
      isVicProduct: isVicProduct,
      disabled: disabled,
      required
    });
  }

  componentDidMount() {
    this.analyticsCheckout('Checkout', this.props.order.orderNumber);
    this.trackCheckoutAbandonedCart('Checkout',  this.props.order.quotes ? this.props.order.quotes.quotes : []);
    const cookies = new Cookies();

    //Reset all form LOADERS
    this.props.resetCheckoutLoaders();

    //Reset ABN Lookup props
    this.props.resetAbnLookupProps();

    //Reset Address Lookup props
    this.props.resetAddressLookupProps();

    if (this.props.login.userLoggedIn) {
      this.props.fetchCurrentOrder().then(
        function (fetchCurrentOrderAction) {
          const order = (fetchCurrentOrderAction && fetchCurrentOrderAction.data && fetchCurrentOrderAction.data.order) ? fetchCurrentOrderAction.data.order : this.props.order;
          if (
            order &&
            order.quotes &&
            order.quotes.quotes &&
            order.quotes.quotes.length > 0
          ) {
            // check order if there is real estate product
            order.quoteConfiguration.products.forEach((product) => {
              if (product.configuration.industry) {
                cookies.set('industry', product.configuration.industry);
              } else {
                cookies.remove('industry');
              }
            });

            this.resetOrder(order);
            this.props.getAccounts(null).then(
              function () {
                this.checkExistingAccounts();

                if (this.props.login.relogin) {
                  this.props.redirectToLoginPage();
                }
              }.bind(this)
            );
          } else {
            history.push('/cart');
          }
        }.bind(this)
      );
    } else {
      history.push('/cart');
    }

    this.props.resetPurchaseEvent();

    window.scrollTo(0, 0);
  }

  checkAndFillIncompleteAbnDetails(abnDetails) {
    let customerDetails = this.state.customer;
    let errorMessages = this.state.errorMessages;

    // when abn returns business name but missing organisation name
    if (abnDetails?.businessName && abnDetails?.organisationName === '') {
      customerDetails.abn = abnDetails.abn;
      customerDetails.businessName = abnDetails.businessName;
      customerDetails.legalEntityName = abnDetails.businessName;
      errorMessages.abnInvalid = false;

      // when abn returns organisation name but missing business name
    } else if (abnDetails?.businessName === '' && abnDetails?.organisationName) {
      customerDetails.abn = abnDetails.abn;
      customerDetails.businessName = abnDetails.organisationName;
      customerDetails.legalEntityName = abnDetails.organisationName;
      errorMessages.abnInvalid = false;

      // when abn returns both business and organisation name
    } else if (abnDetails?.businessName && abnDetails?.organisationName) {
      customerDetails.abn = abnDetails.abn;
      customerDetails.businessName = abnDetails.businessName;
      customerDetails.legalEntityName = abnDetails.organisationName;
      errorMessages.abnInvalid = false;

      // when abn is invalid
    } else if (
      customerDetails?.businessName === '' &&
      customerDetails?.legalEntityName === '' &&
      abnDetails?.businessName === '' &&
      abnDetails?.organisationName === ''
    ) {
      customerDetails.businessName = '';
      customerDetails.legalEntityName = '';
      errorMessages.abnInvalid = true;
    }

    this.setState({
      customer: customerDetails,
      errorMessages: errorMessages
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.abn !== this.props.abn) {
      // Check only if ABN is auto-filled.
      if (
        !this.state.abnManualEntry &&
        this.state.customer.abn &&
        this.props.abn &&
        this.state.customer.purpose != 'Personal'
      ) {
        this.checkAndFillIncompleteAbnDetails(this.props.abn);
      }

      // Validation check for ABN success response.
      this.validateAbnResponse(this.props.abn);
    }

    if (prevProps.abnError !== this.props.abnError) {
      // Handle ABN failure response.
      this.enterBusinessDetailsManuallyIfAbnLookupIsDown(this.props.abnError);
    }

    if (prevProps.addressError !== this.props.addressError) {
      // Handle address failure response.
      this.enterAddressDetailsManuallyIfAddressLookupIsDown(this.props.addressError);
    }
  }

  forceAddressManualEntry() {
    return (this.props.addressError && this.state.manualEntry);
  }

  enterAddressDetailsManuallyIfAddressLookupIsDown(addressLookupError) {
    setTimeout(() => {
      if (
          addressLookupError &&
          !this.state.manualEntry &&
          this.state.customer.singleAddressLine?.length > ADDRESS_LOOKUP_AUTO_MANUAL_ENTRY_TRIGGER_LENGTH
      ) {
        let customer = this.state.customer;
        customer.streetAddress = null;
        customer.suburbCity = null;
        customer.state = null;
        customer.postcode = null;
        this.setState({customer: customer}, () => this.onAddressManualEntry());
      }
    }, 2000);
  }

  enterBusinessDetailsManuallyIfAbnLookupIsDown(abnLookupIsDown) {
    if (abnLookupIsDown && !this.state.abnManualEntry) this.onAbnManualEntry();
  }

  validateAbnResponse(abn) {
    if (
      this.state.customer.abn &&
      !this.state.abnManualEntry &&
      'businessName' in abn &&
      'organisationName' in abn
    ) {
      let customerDetails = this.state.customer;
      let errorMessages = this.state.errorMessages;
      const { businessName, organisationName } = abn;

      errorMessages['abn'] = (businessName.length === 0 && organisationName.length === 0);
      if (errorMessages['abn']) {
        customerDetails.businessName = '';
        customerDetails.legalEntityName = '';
        this.setState({customer: customerDetails});
      }

      this.setState({errorMessages: errorMessages});
    }
  }

  hideEOFYOffer() {
    this.setState({
      showEOFYOffer: false
    });
  }

  checkExistingAccounts() {
    if (this.props.login.accounts.length > 0) {
      let init = {
        target: {
          name: 'accountType',
          value: 'EXISTING_ACCOUNT'
        }
      };
      this.onAccountTypeSelectorChange(init);
      if (this.props.login.accounts.length === 1) {
        //check if acc is in blacklist
        let blacklist_accs = BLACKLIST_ACCOUNTS.map((acc) => acc.toLowerCase());
        if (!blacklist_accs.includes(this.props.login.accounts[0].accountNumber.toLowerCase())) {
          let account = {
            target: {
              name: 'accountReferenceNumber',
              value: this.props.login.accounts[0].accountNumber
            }
          };
          this.onAccountSelectorChange(account);
        }
      }
    }
  }

  onAccountTypeSelectorChange(event) {
    let customerDetails = this.state.customer;
    let requiredFields = this.state.required;
    let errorMessages = this.state.errorMessages;
    let disabled = this.state.disabled;

    let key, value;
    key = event.target.name;
    value = event.target.value;

    if (value === 'NEW_ACCOUNT') {
      requiredFields.accountReferenceNumber = false;
        disabled.abn = false;
    } else {
      requiredFields.accountReferenceNumber = true;
    }

    disabled.singleAddressLine = false;
    errorMessages.accountReferenceNumber = false;
    errorMessages.accountReferenceNumberValid = false;
    customerDetails.accountReferenceNumber = null;
    errorMessages[key] = false;
    customerDetails[key] = value;

    this.setState({
      customer: customerDetails,
      disabled: disabled,
      errorMessages: errorMessages,
      required: requiredFields
    });
    this.onInputChange(event);
  }

  onAccountSelectorChange(event) {
    // this.props.getRoles(event.target.value)
    if (event.target.value !== '') {
      this.props.getAccountInfo(event.target.value).then(
        function (accountInfoAction) {
          let errorMessages = this.state.errorMessages;
          let disabled = this.state.disabled;
          let customer = this.state.customer;
          let accountDetails = (accountInfoAction && accountInfoAction.data) ? accountInfoAction.data : this.props.accountDetails;

          if (accountDetails) {
            if (accountDetails.addressLine1) {
              customer.singleAddressLine = `${accountDetails.addressLine1} `;
              customer.streetAddress = `${accountDetails.addressLine1} `;
              disabled.singleAddressLine = true;
            }
            if (accountDetails.addressLine2) {
              customer.singleAddressLine += `${accountDetails.addressLine2} `;
              customer.streetAddress += accountDetails.addressLine2;
              disabled.singleAddressLine = true;
            }
            if (accountDetails.city) {
              customer.singleAddressLine += `${accountDetails.city} `;
              customer.suburbCity = accountDetails.city;
              disabled.singleAddressLine = true;
            }
            if (accountDetails.state) {
              customer.singleAddressLine += `${accountDetails.state} `;
              customer.state = STATE_ABBREVIATIONS[accountDetails.state.toLowerCase()];
              disabled.singleAddressLine = true;
            }
            if (accountDetails.postalCode) {
              customer.singleAddressLine += accountDetails.postalCode;
              customer.postcode = accountDetails.postalCode;
              disabled.singleAddressLine = true;
            }
            if (accountDetails.country) {
              customer.country = accountDetails.country;
            }
            if (accountDetails.businessNumber) {
              customer.abn = accountDetails.businessNumber;
              disabled.abn = true;
              errorMessages.abnFormat = false;
              errorMessages.abn = false;
              errorMessages.abnManual = false;
              errorMessages.abnInvalid = false;
            }
            if (accountDetails.tradingName) {
              customer.legalEntityName = accountDetails.tradingName;
              errorMessages.legalEntityName = false;
            }
            if (accountDetails.organizationName) {
              customer.businessName = accountDetails.organizationName;
              errorMessages.businessName = false;
            }
            if (customer.singleAddressLine) {
              errorMessages.singleAddressLine = false;
            }
            if (customer.title) {
              disabled.title = true;
            }

            this.setState({
              customer: customer,
              errorMessages: errorMessages,
              disabled: disabled,
              mailingAddressAutocomplete: true,
              addressOption: false
            });
          }
        }.bind(this)
      );
    }

    this.onInputChange(event);
  }

  onManualAccountInputChange(event) {
    if (event.target.value !== '') {
      this.props.validateAccountReferenceNumber(event.target.value).then(
        function (validateRefAction) {
          let errorMessages = this.state.errorMessages;
          let isValidAccountReferenceNumber = validateRefAction !== undefined ? validateRefAction.data : this.props.isValidAccountReferenceNumber;

          errorMessages.accountReferenceNumberValid = !isValidAccountReferenceNumber;

          this.setState({
            errorMessages: errorMessages
          });
        }.bind(this)
      );
    }
  }

  checkHasSubscription(order) {
    if (!order?.quotes?.quotes) {
      return false;
    }

    for (let i = 0; i < order.quotes.quotes.length; i++) {
      const packageName = order.quotes.quotes[i].packageName;

      if (packageName !== 'one_month' && packageName !== 'trial') {
        return true;
      }
    }

    return false;
  }

  subscriptionPopup = this.checkHasSubscription(this.props.order);

  render() {
    const containsRPPTrial = this.state.rppProduct &&
      this.state.rppProduct !== "investors" &&
      this.state.quotes.some(e => e.type === "RPPRealEstate") &&
      this.state.quotes.some(e => e.packageName === "trial")
    const isNot1MonthProduct = this.checkHasSubscription(this.props.order)
    return (
      <div>
        <div className='container-fluid'>
          {this.props.order && Object.keys(this.props.order).length > 0 && (
            <div className='row page-dim margin-bottom-100'>
              <div className='col-md-8'>
                <div className='row no-margin'>
                  <div className='col-sm-12'>
                    <div className='row'>
                      <div className='checkout-section-title heading1 text-center'>Checkout</div>
                    </div>
                  </div>
                </div>
                <CustomerForm
                  customerDetails={this.state.customer}
                  totalDays={this.state.totalDays}
                  totalMonths={this.state.totalMonths}
                  userTotalMonths={this.state.userTotalMonths}
                  onInputChange={this.onInputChange}
                  onSubmitCustomerDetails={this.onSubmitCustomerDetails}
                  submitBufferLoader={this.state.submitBufferLoader}
                  totalPrice={this.state.totalPrice}
                  showBusinessOption={this.state.showBusinessOption}
                  business={this.state.business}
                  onChangeBusinessOption={this.onChangeBusinessOption}
                  address={this.props.address}
                  onAddressInputChange={this.onAddressInputChange}
                  addressOption={this.state.addressOption}
                  onAddressFocus={this.onAddressFocus}
                  onAddressSelection={this.onAddressSelection}
                  abn={this.props.abn}
                  abnError={this.props.abnError}
                  errorMessages={this.state.errorMessages}
                  disabled={this.state.disabled}
                  onAddressManualEntry={this.onAddressManualEntry}
                  manualEntry={this.state.manualEntry}
                  forceAddressManualEntry={this.forceAddressManualEntry}
                  onAddressCancelManualEntry={this.onAddressCancelManualEntry}
                  onAbnManualEntry={this.onAbnManualEntry}
                  onAbnCancelManualEntry={this.onAbnCancelManualEntry}
                  abnManualEntry={this.state.abnManualEntry}
                  errors={this.state.errors}
                  paymentLoader={this.props.paymentLoader}
                  contactsLoader={this.props.contactsLoader}
                  quotes={this.state.quotes}
                  conditionalTC={this.state.conditionalTC}
                  rppProduct={this.state.rppProduct}
                  originalTotalPrice={this.state.originalTotalPrice}
                  login={this.props.login}
                  onAccountSelectorChange={this.onAccountSelectorChange}
                  onManualAccountInputChange={this.onManualAccountInputChange}
                  onAccountTypeSelectorChange={this.onAccountTypeSelectorChange}
                  backToCart={this.backToCart}
                  submitLoader={this.props.submitLoader}
                  isReport={this.state.isReport}
                  couponEntity={this.state.coupon}
                  isYearlyCouponApplied={this.isYearlyCouponApplied}
                  isRPP={this.state.isRPP}
                  containsRPPTrial={containsRPPTrial}
                />
              </div>
              <div className='col-md-4'>
                <OrderSummary
                  totalDays={this.state.totalDays}
                  totalMonths={this.state.totalMonths}
                  userTotalMonths={this.state.userTotalMonths}
                  quotes={this.state.quotes}
                  order={this.state.order}
                  totalPrice={this.state.totalPrice}
                  monthsDiscount={this.state.monthsDiscount}
                  minCost={this.state.minCost}
                  originalTotalPrice={this.state.originalTotalPrice}
                  isAgentVisbile={this.state.isAgentVisbile}
                  coupon={this.state.coupon}
                  isYearlyCouponApplied={this.isYearlyCouponApplied}
                  isMultipleYearlyCouponOrder={this.isMultipleYearlyCouponOrder}
                />
              </div>
              <Modal show={this.state.show}>
                {
                  isNot1MonthProduct &&
                  <>
                    <Modal.Header>
                      <Modal.Title>
                        <p className='text-center no-margin font-14 semi-bold'>
                          Subscription Notification
                        </p>
                      </Modal.Title>
                    </Modal.Header>
                    <div className='text-center no-margin font-14 padding-20'>
                    Please note, you are about to enter a subscription with monthly repayments.
                    Subscription details are on the Checkout page. Please click on Continue if
                    you wish to proceed or Back if you would like to stay on the Checkout page.
                    </div>
                  </>
                }
                {
                  this.state.isVicProduct &&
                  <>
                    <Modal.Header>
                      <Modal.Title>
                        <p className='text-center no-margin font-14 semi-bold'>
                          Owner Details - Victoria
                        </p>
                      </Modal.Title>
                    </Modal.Header>

                    <div className='text-center no-margin font-14 padding-20'>
                      Victorian Legislation requires Real Estate Agents and Valuers to fill out a Deed
                      4 to be able to access Owners Details. You will receive the form and
                      instructions attached to your confirmation email.
                    </div>
                  </>
                }
                <Modal.Body>
                  <button
                    type='button'
                    className={
                      this.props.submitLoader || this.state.submitBufferLoader
                        ? 'btn btn-primary btn-20 margin-bottom-20 disabled'
                        : 'btn btn-primary btn-20 margin-bottom-20'
                    }
                    onClick={() => {
                      if (this.state.isVicProduct) {
                        this.setState({
                          vicDeedFormPopup: true
                        })
                      }
                      if (isNot1MonthProduct) {
                        this.setState({
                          subscriptionPopup: true
                        });
                      }
                      this.handleClose();
                    }}
                  >
                    Back
                    {(this.props.submitLoader || this.state.submitBufferLoader) && (
                      <span>
                        <i className='fa fa-spinner fa-pulse fa-fw'></i>
                        <span className='sr-only'>Loading...</span>
                      </span>
                    )}
                  </button>
                  <button
                    id='checkout-continue-btn'
                    type='button'
                    className={
                      this.props.submitLoader || this.state.submitBufferLoader
                        ? 'btn btn-primary btn-20 margin-bottom-20 disabled'
                        : 'btn btn-primary btn-20 margin-bottom-20'
                    }
                    onClick={() => {
                      this.onSubmitCustomerDetails(this.state.pendingPaymentType);
                    }}
                  >
                    Continue
                    {(this.props.submitLoader || this.state.submitBufferLoader) && (
                      <span>
                        <i className='fa fa-spinner fa-pulse fa-fw'></i>
                        <span className='sr-only'>Loading...</span>
                      </span>
                    )}
                  </button>
                </Modal.Body>
              </Modal>
              <Modal show={this.state.showEOFYOffer}>
                <Modal.Body>
                  <div className='text-center no-margin font-14 padding-20'>
                    Please ensure only the products included in your cart are Cityscope, Cordell
                    Connect, Cordell Estimator Platinum, Lease Expiry Diary, RP Data.
                    Please remove excluded products from your cart before proceeding to payment.
                  </div>
                  <button
                    type='button'
                    className='btn btn-primary btn-20 margin-bottom-20'
                    onClick={this.hideEOFYOffer}
                  >
                    Proceed
                  </button>
                </Modal.Body>
              </Modal>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    order: state.cart.order,
    cart: state.cart.cart,
    address: state.checkout.address,
    abn: state.checkout.abn,
    abnError: state.checkout.abnError,
    addressError: state.checkout.addressError,
    paymentLoader: state.checkout.paymentLoader,
    contactsLoader: state.checkout.contactsLoader,
    submitLoader: state.checkout.submitLoader,
    login: state.login,
    accountDetails: state.checkout.accountDetails,
    propertyDetails: state.checkout.propertyDetails,
    registration: state.registration,
    isValidAccountReferenceNumber: state.checkout.isValidAccountReferenceNumber,
    hmcw: state.packageSelection.hmcw,
    apiErrorMessages: state.checkout.errorMessages,
    contactInfo: state.checkout.contactInfo
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveCustomerDetails: (customerDetails, type, paymentDetails) =>
      dispatch(saveCustomerDetails(customerDetails, type, paymentDetails)),
    updateContactInfo: (contactInfo) =>
        dispatch(updateContactInfo(contactInfo)),
    addressLines: (address) => dispatch(addressLines(address)),
    fetchAbnDetails: (abn) => dispatch(fetchAbnDetails(abn)),
    fetchCurrentOrder: () => dispatch(fetchCurrentOrder()),
    getRoles: (accountGuid) => dispatch(getRoles(accountGuid)),
    getAccounts: (code) => dispatch(getAccounts(code)),
    getAccountInfo: (accountNumber) => dispatch(getAccountInfo(accountNumber)),
    redirectToLoginPage: () => dispatch(redirectToLoginPage()),
    userExpirySession: () => dispatch(userExpirySession()),
    getPropertyDetails: (propertyId) => dispatch(getPropertyDetails(propertyId)),
    resetCheckoutLoaders: () => dispatch(resetCheckoutLoaders()),
    resetAbnLookupProps: () => dispatch(resetAbnLookupProps()),
    resetAddressLookupProps: () => dispatch(resetAddressLookupProps()),
    validateAccountReferenceNumber: (accountReferenceNumber) =>
      dispatch(validateAccountReferenceNumber(accountReferenceNumber)),
    resetPurchaseEvent: () => dispatch(resetPurchaseEvent())
  };
};

let CheckoutPage = connect(mapStateToProps, mapDispatchToProps)(Checkout);

export default CheckoutPage;
